import React from 'react';
import { useTranslation } from 'react-i18next';
import { ConfirmationModalProps } from '~/Components';
import { IStaff } from '~/Models/DTO/Staff.model';
import { IMenuAction } from '~/Models/interfaces/menuAction.models';
import { StaffDeactivationDeletion } from './StaffDeactivationDeletion';

export const useStaffDeletionModal: ({
  setConfirmationModalProps,
}: {
  setConfirmationModalProps: React.Dispatch<React.SetStateAction<ConfirmationModalProps>>;
}) => (item: IStaff) => IMenuAction = ({ setConfirmationModalProps }) => {
  const { t } = useTranslation();

  const DeletionContent = (item: IStaff) => (
    <StaffDeactivationDeletion
      staff={item}
      setConfirmationModalProps={setConfirmationModalProps}
      isInDeletionMode
    />
  );

  const onClick: (staff: IStaff) => IMenuAction['onClick'] = (staff) => () => {
    setConfirmationModalProps({
      open: true,
      title: t('app.delete'),
      children: DeletionContent(staff),
      cancel: { title: t('app.cancel') },
      confirm: {
        title: t('app.delete'),
        disabled: true,
        isLoading: true,
        color: 'error',
      },
    });
  };

  return (item: IStaff) => ({
    name: t('app.delete'),
    onClick: onClick(item),
  });
};
